<template>
	<div>
		<div class="border-bottom pb-3 mb-6">
            <div class="display-3 kp-title">Tracks</div>
        </div>
        <div class="border-bottom pb-3 mb-7">
		    <div class="d-flex align-items-center mb-5">
		        <h3 class="card-title mb-0 text-muted">
		            All Tracks
		        </h3>
		    </div>
		    <div>
		        <table class="table table-vcenter table-edge">
		            <thead>
		                <tr>
		                    <th class="w-25">
		                        Name
		                    </th>
		                    <th>
		                        Description
		                    </th>
		                    <th>
		                        ID
		                    </th>
		                    <th>
		                        Created
		                    </th>
		                    <th>
		                    </th>
		                </tr>
		            </thead>
		            <tbody>
		                <tr v-for="item in items">
		                    <td>
		                        <router-link :to="{name: 'track-details', params: {id: item.id}}">{{item.name}}</router-link>
		                    </td>
		                    <td>{{item.description}}</td>
		                    <td>{{item.id}}</td>
		                    <td>{{item.createdAt | df}}</td>                    
		                </tr>		                               
		            </tbody>
		        </table>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import {HTTP} from '@/components/HTTP.js'
	import DateFormat from '@/components/DateFilter.js'

	export default {
		created: function(){
			this.fetch()
		},
		filters: {
			df: DateFormat
		},
		data: function(){
			return {
				items:[]
			}
		},
		methods: {
			fetch: function(){
				HTTP.get('e/tracks')
	  			.then((res) => {
	  				if (res.data.status) {
	  					this.items = res.data.data.tracks;
	  				}	  				
	  			})
	  			.catch((e) => {
	  				console.log("Error response", e);
	  			})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/tracks/Index.vue